import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { obtenerInformacion } from '../../actions/dashboard';

const Dashboard = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: '',
            path: '/dashboard'
        }
    ];

    const dispatch = useDispatch();

    const usuario = useSelector(state => state.auth.usuario);
    const informacion = useSelector(state => state.dashboard);

    const convertRegistrosDias = (registros, sufijo) => {
        let dias = 0;
        let cantidad_dia = 1000 * 60 * 60 * 24;
        let ano_actual = new Date().getFullYear();
        let primer_dia = new Date(ano_actual, 0, 1);
        let final_dia = new Date((ano_actual + 1), 0, 1);

        if(registros?.length > 0){
            for (var i = 0; i < registros.length; i++) {
                if(registros[i].periodos.length > 0){
                    for (var x = 0; x < registros[i].periodos.length; x++) {
                        if(new Date(registros[i].periodos[x].inicio).getTime() >= primer_dia.getTime() && new Date(registros[i].periodos[x].fin).getTime() < final_dia.getTime()){
                            let diferencia = Math.floor(new Date(registros[i].periodos[x].fin).getTime() - new Date(registros[i].periodos[x].inicio).getTime());
                            dias += Math.floor(diferencia / cantidad_dia) + 1;
                        }else{
                            if(new Date(registros[i].periodos[x].inicio).getTime() >= primer_dia.getTime() && new Date(registros[i].periodos[x].inicio).getTime() < final_dia.getTime()){
                                let fecha_inicial = new Date(registros[i].periodos[x].inicio);

                                while(fecha_inicial.getTime() >= primer_dia.getTime() && fecha_inicial.getTime() < final_dia.getTime()){
                                    dias++;
                                    fecha_inicial.setDate(fecha_inicial.getDate() + 1);
                                }
                            }else{
                                let fecha_final = new Date(registros[i].periodos[x].fin);

                                while(fecha_final.getTime() >= primer_dia.getTime() && fecha_final.getTime() < final_dia.getTime()){
                                    dias++;
                                    fecha_final.setDate(fecha_final.getDate() - 1);
                                }
                            }
                        }
                    }
                }
            }
        }

        return sufijo ? (dias + (dias == 1 ? ' día' : ' dias')) : dias;
    }

    const convertFechaTiempo = (fecha) => {
        let mensaje = 'Sin definir';

        if(fecha && fecha != '0000-00-00'){
            let diferencia = Math.floor(new Date().getTime() - new Date(fecha).getTime());
            let cantidad_dia = 1000 * 60 * 60 * 24;

            let dias = Math.floor(diferencia / cantidad_dia);
            let meses = 0;
            let anos = 0;

            if(dias >= 365){
                anos = Math.floor(dias / 365);
                dias = dias - (anos * 365);
            }

            if(dias >= 30){
                meses = Math.floor(dias / 30);
                dias = dias - (meses * 30);
            }

            let texto_dias = dias ? (dias + ' ' + (dias == 1 ? 'dia' : 'dias')) : '';
            let texto_meses = meses ? (meses + ' ' + (meses == 1 ? 'mes' : 'meses')) : '';
            let texto_anos = anos ? (anos + ' ' + (anos == 1 ? 'año' : 'años')) : '';

            mensaje = texto_anos + ' ' + texto_meses + ' ' + texto_dias;
        }

        return mensaje;
    }

    useEffect(() => {
        dispatch(obtenerInformacion());
    }, []);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <div className="container">
                <h1 className="display-3 mb-3">¡Hola {usuario?.nombre}!</h1>
                <p>Desde Veti <b>Admin</b> podrás realizar funciones en relación a lo administrativo y a tu perfil en la clínica.</p>
            </div>

            <div class="container dashboard">
                <div class="row g-4">
                    <div class="col-md-6 col-lg-6 my-4">
                        <div class="card dashboard-card p-3">
                            <div class="card-title">⏳ Tiempo en la empresa</div>
                            <p class="card-text text-muted">{ informacion?.contrataciones ? convertFechaTiempo(informacion?.contrataciones[0]?.inicio) : 'Sin definir' }</p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-6 my-4">
                        <div class="card dashboard-card p-3">
                            <div class="card-title">🎂 Próximo cumpleaños</div>
                            <p class="card-text text-muted">{ informacion?.cumpleanos?.length ? (informacion?.cumpleanos[0].nombre + ' ' + informacion?.cumpleanos[0].apellido + ' - ' + new Date(informacion?.cumpleanos[0].fecha).toLocaleDateString('es-MX', { month: 'long', day: 'numeric' })) : 'Sin cumpleaños próximo'}</p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-6 my-4">
                        <div class="card dashboard-card p-3">
                            <div class="card-title">🏖️ Vacaciones tomadas</div>
                            <p class="card-text text-muted">{ convertRegistrosDias(informacion?.vacaciones, true) }</p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-6 my-4">
                        <div class="card dashboard-card p-3">
                            <div class="card-title">📆 Vacaciones restantes</div>
                            <p class="card-text text-muted">{ informacion?.dias_vacaciones ? ((informacion?.dias_vacaciones - convertRegistrosDias(informacion?.vacaciones, false)) == 1 ? (informacion?.dias_vacaciones - convertRegistrosDias(informacion?.vacaciones, false)) + ' día' : (informacion?.dias_vacaciones - convertRegistrosDias(informacion?.vacaciones, false)) + ' dias') : '0 dias' }</p>
                        </div>
                    </div>
                </div>
                </div>
        </Fragment>
    )
}

export default Dashboard;